var _polygon, _polygon2;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBetslipPrematch = function SvgBetslipPrematch(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "583.003px",
    height: "212.604px",
    viewBox: "0 0 583.003 212.604",
    enableBackground: "new 0 0 583.003 212.604",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pre_match_grad_1",
    gradientUnits: "userSpaceOnUse",
    x1: 65.8506,
    y1: 106.3018,
    x2: 583.0029,
    y2: 106.3018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F84E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7163,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#pre_match_grad_1)",
    points: "583.003,0 487.422,0 249.971,0 191,0 65.851,212.603 249.971,212.603 487.422,212.603  487.422,212.604 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1F84E6",
    points: "31,0 0,0 0,212.604 31,212.604 156.333,0 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBetslipPrematch, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI1ODMuMDAzcHgiIGhlaWdodD0iMjEyLjYwNHB4IiB2aWV3Qm94PSIwIDAgNTgzLjAwMyAyMTIuNjA0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1ODMuMDAzIDIxMi42MDQiCgkgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxsaW5lYXJHcmFkaWVudCBpZD0icHJlX21hdGNoX2dyYWRfMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSI2NS44NTA2IiB5MT0iMTA2LjMwMTgiIHgyPSI1ODMuMDAyOSIgeTI9IjEwNi4zMDE4Ij4KCTxzdG9wICBvZmZzZXQ9IjAiIHN0eWxlPSJzdG9wLWNvbG9yOiMxRjg0RTYiLz4KCTxzdG9wICBvZmZzZXQ9IjAuNzE2MyIgc3R5bGU9InN0b3AtY29sb3I6I0ZGRkZGRjtzdG9wLW9wYWNpdHk6MCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8cG9seWdvbiBmaWxsPSJ1cmwoI3ByZV9tYXRjaF9ncmFkXzEpIiBwb2ludHM9IjU4My4wMDMsMCA0ODcuNDIyLDAgMjQ5Ljk3MSwwIDE5MSwwIDY1Ljg1MSwyMTIuNjAzIDI0OS45NzEsMjEyLjYwMyA0ODcuNDIyLDIxMi42MDMgCgk0ODcuNDIyLDIxMi42MDQgIi8+Cjxwb2x5Z29uIGZpbGw9IiMxRjg0RTYiIHBvaW50cz0iMzEsMCAwLDAgMCwyMTIuNjA0IDMxLDIxMi42MDQgMTU2LjMzMywwICIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };